import React from "react";
import { Box, Flex, Link, Text } from "@chakra-ui/react";
import { Logo } from "@/components/Icons";

const Footer = () => {
  return (
    <Box as="footer" bg="textBlack.200" w="full" borderTopWidth="1px" borderTopColor="grey.100">
      <Flex
        alignItems={{ base: "flex-start", md: "center" }}
        justifyContent="space-between"
        gap={6}
        flexDir={{ base: "column", md: "row" }}
        maxW="8xl"
        mx="auto"
        px={{ base: 6, md: 0 }}
        py={6}
      >
        <Flex flexDir="column" gap={3}>
          <Flex gap={6} flexWrap="wrap">
            <Link
              href="https://hartak.am/pages/arm-privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              textStyle="link.standard"
              color="black"
              _focus={{ animation: "accessibility-outline-pulse 300ms ease-in-out" }}
              _active={{ animation: "accessibility-outline-pulse 300ms ease-in-out" }}
            >
              Անձնական տվյալների մշակում
            </Link>
            {/* <Link href="#" textStyle="link.standard" color="black">
              Մատչելիության հայտարարություն
            </Link> */}
          </Flex>
          <Text textStyle="body.regular" color="black">
            © {new Date().getFullYear()} Ծառայությունների միասնական հարթակ
          </Text>
        </Flex>

        <Logo w="96px" h="90px" color="grey.500" display={{ base: "none", md: "block" }} />
      </Flex>
    </Box>
  );
};

export default Footer;
